import React from 'react';
import PropTypes from 'prop-types';
import {
    injectIntl,
    intlShape
} from 'react-intl';

import css from './index.scss';

import PortalCommunication from '../../../../portal-comms';
import messages from '../../messages';

import Button from '../../../button';

const PrivacySettingsFooter = ({
    intl,
    isSaveInProgress,
    isOptionsUpdated,
    saveRequest,
    handleOnSave
}) => {
    /**
     * FUNCTIONS
     */
    const savePreferences = () => {
        const request = {
            preferences: saveRequest.filter(r => r.value !== -1)
        };
        handleOnSave(request);
    };

    /**
     * RENDER
     */
    return (
        <div className={css.privacySettingsFooter}>
            <Button
                containerClassName={css.cancelButton}
                disabled={isSaveInProgress}
                handleOnClick={() => { PortalCommunication.navigateToLandingScreen('Settings'); }}
                label={intl.formatMessage(messages.cancel)}
            />
            <Button
                containerClassName={css.saveButton}
                disabled={isSaveInProgress || !isOptionsUpdated}
                handleOnClick={savePreferences}
                label={intl.formatMessage(messages.save)}
            />
        </div>
    );
};

PrivacySettingsFooter.propTypes = {
    /**
     * Manages on save button click save api service request
     */
    handleOnSave: PropTypes.func,
    /**
     * Used to manage translations
     */
    intl: intlShape.isRequired,
    /**
     * Have the student settings changed from previous save request
     */
    isOptionsUpdated: PropTypes.bool,
    /**
     * Is save api service request in progress
     */
    isSaveInProgress: PropTypes.bool,
    /**
     * Items sent to save api service
     */
    saveRequest: PropTypes.array
};

export default injectIntl(PrivacySettingsFooter);



// WEBPACK FOOTER //
// ./app/components/privacy-settings/sub-components/privacy-settings-footer/index.js